"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFieldFormats = exports.validators = exports.buildAlertMessage = exports.validateInvoiceFields = exports.hasClientData = exports.canEditClientData = exports.prepareInvoiceData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18next_1 = require("i18next");
const prepareInvoiceData = (invoice) => ({
    ...invoice,
    customer: {
        name: invoice.customer?.name || '',
        taxId: invoice.customer?.taxId || '',
        email: invoice.customer?.email || '',
        phone: invoice.customer?.phone || '',
        address: {
            street: invoice.customer?.address?.street || '',
            city: invoice.customer?.address?.city || '',
            state: invoice.customer?.address?.state || '',
            postalCode: invoice.customer?.address?.postalCode || '',
            country: invoice.customer?.address?.country || '',
        },
    },
});
exports.prepareInvoiceData = prepareInvoiceData;
const canEditClientData = (invoice) => {
    if (!invoice?.orderStartTs)
        return false;
    const now = new Date();
    let orderDate;
    if (isNaN(Number(invoice.orderStartTs))) {
        orderDate = new Date(invoice.orderStartTs);
    }
    else {
        orderDate = new Date(Number(invoice.orderStartTs) * 1000);
    }
    if (orderDate > now)
        return false;
    const hoursDiff = (now.getTime() - orderDate.getTime()) / (1000 * 60 * 60);
    return hoursDiff < 24;
};
exports.canEditClientData = canEditClientData;
const hasClientData = (invoice) => {
    const customer = invoice.customer;
    if (!customer)
        return false;
    const fa = customer.address;
    return !!(customer.name ||
        customer.taxId ||
        customer.email ||
        customer.phone ||
        fa?.street ||
        fa?.city ||
        fa?.state ||
        fa?.postalCode ||
        fa?.country);
};
exports.hasClientData = hasClientData;
const validateInvoiceFields = (invoice, t) => {
    const missingFields = [];
    const fa = invoice.customer.address;
    if (!invoice.customer.name)
        missingFields.push(t('userForm.fullName'));
    if (!fa?.street)
        missingFields.push(t('userForm.street'));
    if (!fa?.country)
        missingFields.push(t('userForm.country'));
    if (!fa?.city)
        missingFields.push(t('userForm.city'));
    if (!fa?.state)
        missingFields.push(t('userForm.state'));
    if (!fa?.postalCode)
        missingFields.push(t('userForm.postalCode'));
    if (!invoice.customer.taxId)
        missingFields.push(t('userForm.taxId'));
    return missingFields;
};
exports.validateInvoiceFields = validateInvoiceFields;
const buildAlertMessage = ({ invoice, isMobile, t, showEditButton, }) => {
    const alertClass = `${isMobile ? 'mt-2 mb-2' : 'mt-5'} w-fit bg-orange-100 text-orange-700 text-xs px-3 py-2 rounded-full`;
    if ((0, exports.canEditClientData)(invoice)) {
        return (0, jsx_runtime_1.jsxs)("div", { className: alertClass, children: ["* ", t('userFormAlert.addData')] });
    }
    if (!(0, exports.hasClientData)(invoice)) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: alertClass, children: ["* ", t('userFormAlert.addDataExpired')] }));
    }
    if (!showEditButton) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: alertClass, children: ["* ", t('userFormAlert.editDataExpired')] }));
    }
    return null;
};
exports.buildAlertMessage = buildAlertMessage;
exports.validators = {
    fullName: (val) => {
        if (!val)
            return (0, i18next_1.t)('validation.required');
        return /^(?!\s*$)[A-Za-zÁÉÍÓÚñáéíóúÑ ]+$/.test(val)
            ? ''
            : (0, i18next_1.t)('validation.fullName');
    },
    taxId: (val) => {
        if (!val)
            return (0, i18next_1.t)('validation.required');
        const value = val.toUpperCase().trim();
        const regex = /^(?:[XYZ]\d{7}[A-Z]|\d{8}[A-Z])$/;
        if (!regex.test(value))
            return (0, i18next_1.t)('validation.taxId');
        const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
        let number;
        if (/^[XYZ]/.test(value)) {
            const prefix = { X: 0, Y: 1, Z: 2 }[value[0]];
            number = parseInt(prefix + value.substring(1, 8));
        }
        else {
            number = parseInt(value.substring(0, 8));
        }
        const correctLetter = letters[number % 23];
        return value.endsWith(correctLetter) ? '' : (0, i18next_1.t)('validation.taxId'); // Letra incorrecta
    },
    email: (val) => {
        if (!val)
            return '';
        return /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(val)
            ? ''
            : (0, i18next_1.t)('validation.email');
    },
    phoneNumber: (val) => {
        if (!val)
            return '';
        return /^\+?\d{9,15}$/.test(val) ? '' : (0, i18next_1.t)('validation.phoneNumber');
    },
    'address.street': (val) => (val ? '' : (0, i18next_1.t)('validation.required')),
    'address.postalCode': (val) => val
        ? /^[0-9]{5}$/.test(val)
            ? ''
            : (0, i18next_1.t)('validation.postalCode')
        : (0, i18next_1.t)('validation.required'),
    'address.city': (val) => (val ? '' : (0, i18next_1.t)('validation.required')),
    'address.state': (val) => (val ? '' : (0, i18next_1.t)('validation.required')),
    'address.country': (val) => (val ? '' : (0, i18next_1.t)('validation.required')),
};
const validateFieldFormats = (invoice) => {
    const validations = [
        {
            value: invoice.customer.name,
            error: invoice.customer.name
                ? exports.validators.fullName(invoice.customer.name)
                : undefined,
            key: 'validation.fullName',
        },
        {
            value: invoice.customer.taxId,
            error: invoice.customer.taxId
                ? exports.validators.taxId(invoice.customer.taxId)
                : undefined,
            key: 'validation.taxId',
        },
        {
            value: invoice.customer.email,
            error: invoice.customer.email
                ? exports.validators.email(invoice.customer.email)
                : undefined,
            key: 'validation.email',
        },
        {
            value: invoice.customer.phone,
            error: invoice.customer.phone
                ? exports.validators.phoneNumber(invoice.customer.phone)
                : undefined,
            key: 'validation.phoneNumber',
        },
        {
            value: invoice.customer.address?.street,
            error: invoice.customer.address?.street
                ? exports.validators['address.street'](invoice.customer.address?.street)
                : undefined,
            key: 'validation.street',
        },
        {
            value: invoice.customer.address?.postalCode,
            error: invoice.customer.address?.postalCode
                ? exports.validators['address.postalCode'](invoice.customer.address?.postalCode)
                : undefined,
            key: 'validation.postalCode',
        },
        {
            value: invoice.customer.address?.city,
            error: invoice.customer.address?.city
                ? exports.validators['address.city'](invoice.customer.address?.city)
                : undefined,
            key: 'validation.city',
        },
        {
            value: invoice.customer.address?.state,
            error: invoice.customer.address?.state
                ? exports.validators['address.state'](invoice.customer.address?.state)
                : undefined,
            key: 'validation.state',
        },
        {
            value: invoice.customer.address?.country,
            error: invoice.customer.address?.country
                ? exports.validators['address.country'](invoice.customer.address?.country)
                : undefined,
            key: 'validation.country',
        },
    ];
    return validations.filter(({ error }) => error).map(({ key }) => (0, i18next_1.t)(key));
};
exports.validateFieldFormats = validateFieldFormats;
